"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prepareInputName;

// some.dot.notated.name => some[dot][notated][name]
function prepareInputName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return name.split('.').map(function (part, index) {
    return index === 0 ? part : "[".concat(part, "]");
  }).join('');
}